export const padding = 16
export const avatarSize = 48
export const gapBetweenAvatarAndContent = padding * 1.2
export const contentSize = 12
export const contentGap = 12
